var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitchLogo = function SvgIconTwitchLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.25a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0v-4.5a1 1 0 0 1 1-1M12.25 8.25a1 1 0 1 0-2 0v4.5a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.478 19.75H11.62l-4.23 3.519A1 1 0 0 1 5.75 22.5v-2.75H4.5A1.75 1.75 0 0 1 2.75 18V4.5A1.75 1.75 0 0 1 4.5 2.75h15a1.75 1.75 0 0 1 1.75 1.75v10.167a1.76 1.76 0 0 1-.63 1.325l-.002.002-4.016 3.342a1.73 1.73 0 0 1-1.124.414M4.75 4.75v13h2a1 1 0 0 1 1 1v1.617l2.648-2.203a1.73 1.73 0 0 1 1.124-.414h3.858l3.87-3.22V4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTwitchLogo;